﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
export class catTiposSolicitudRuta extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposSolicitudRuta";
        this.def.columns.c_category_id.defaultValue = "TiposSolicitudRuta";
        this.Title = "Tipos de Solicitud";
    }
}